<template>
  <div class="p-4" style="overflow-y: auto; height: calc(100vh - 170px);" >
    <!-- Header -->
    <div class="d-flex align-items-center mb-4">
      <img :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}?w=400`" alt="logo" style="height: 70px;" class="mr-4"/>
      <div class="ml-auto d-flex align-items-center">
        <div class="mr-4">
          <input class="mr-2" type="checkbox" v-model="onlyPassed" id="onlyPassed" />
          <label for="onlyPassed">Тэнцсэн бүртгэлүүд</label>
        </div>
        <b-button @click="printPdf()" variant="primary">Хэвлэх</b-button>
      </div>
    </div>
    <div ref="pdfContent">

      <div class="card shadow-sm mb-4">
        <div class="card-body">
          <div class="row">
            <div class="col-md-8">
              <div class="border-right">
                <div class="card-header bg-light text-dark font-weight-bold">Шалгалтын түүх</div>
                <table class="table table-sm table-borderless">
                  <tbody>
                    <tr>
                      <td class="font-weight-bold">Овог нэр:</td>
                      <td>{{ user.ovog }} {{ user.ner }}</td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold">Регистрийн дугаар:</td>
                      <td>{{ user.register }}</td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold">Огноо:</td>
                      <td>{{ '2025.03.15' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card-header bg-light text-dark font-weight-bold">Огноо</div>
              <table class="table table-sm table-borderless mt-2">
                <tbody>
                  <tr>
                    <td class="font-weight-bold">Бүртгэгдсэн өдөр:</td>
                    <td>{{ user.createdDate | moment("YYYY.MM.DD") }}</td>
                    <!-- <td>{{ user.createdDate | moment("YYYY.MM.DD") }}</td> -->
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      
      <!-- {{ lastExams.length }} -->
      <!-- Exam Tables -->
      <!-- {{ lastExams.length }} -->
      <div v-for="(type) in examTypes.filter(e => e.parentId==0)" :key="type.id" class="mb-4">
        <h5 style="margin-bottom: 10px;" class="font-weight-bold">Шалгалтын нэр /{{ type.title }}/</h5>

        <div class="card shadow-sm">
            <div class="card-body p-0">
              <table class="table table-bordered table-hover wd-100p mb-0" cellspacing="0">
                  <thead class="bg-light">
                      <tr>
                          <th class="font-weight-bold">Шалгалтын нэр</th>
                          <th class="font-weight-bold">Үр дүн</th>
                          <th class="font-weight-bold">Авсан оноо</th>
                          <th class="font-weight-bold">Шалгалт өгсөн огноо</th>
                          <th class="font-weight-bold">Шалгалтын хүчинтэй хугацаа</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-if="examTypes.filter(x=>x.parentId==type.id).length == 0">
                          <td colspan="5" class="text-center bg-gray-50 text-muted">Шалгалт оруулаагүй байна</td>
                      </tr>

                      <!-- examTypes.filter(x=>x.parentId==type.id && lastExams.filter(x=>x.locTypeId==exam.id).length > 0 && (lastExams.filter(x=>x.locTypeId==exam.id)[0].perc >= x.tentsehHuvi && x.tentsehHuvi>0)) :  -->
                      <!-- examTypes.filter(x=>x.parentId==type.id && lastExams.filter(ls=>ls.locTypeId==exam.id && ls?.passed).length > 0) -->
                      <tr v-else v-show="onlyPassed ? lastExams.filter(x=>x.locTypeId==exam.id && x.isTentssen).length>0 : true" v-for="(exam, i) in examTypes.filter(x=>x.parentId==type.id)" :key="i">
                          <td>{{ exam.title }}</td>
                          <template v-if="turliinShalgaltiigUgsunEseh(exam.id)">
                            <td>{{ getResult(lastExams.filter(x=>x.locTypeId==exam.id)[0]) }}</td>
                            <td>{{ getScore(lastExams.filter(x=>x.locTypeId==exam.id)[0]) }}</td>
                            <td>{{ lastExams.filter(x=>x.locTypeId==exam.id)[0].dueStartDate | moment("YYYY.MM") }}</td>
                            <td>{{ getValidity(lastExams.filter(x=>x.locTypeId==exam.id)[0]) }} 
                              <a v-if="!hideprint && lastExams.filter(x=>x.locTypeId==exam.id)[0].courseCertificateView==1" @click="showCert(lastExams.filter(x=>x.locTypeId==exam.id)[0])" 
                              class="btn btn-xs btn-primary no-print">Сертификат татах</a>
                            </td>
                          </template>
                          <td v-else colspan="4" class="text-center bg-gray-50 text-muted">Шалгалт өгөөгүй байна</td>
                      </tr>
                  </tbody>
              </table>
            </div>
          </div>
      </div>

      <!-- {{ examTypes.filter(e => e.parentId==0).map(e => e.title) }} -->
      <div v-for="(group, groupName) in groupedExams" :key="groupName" class="mb-4">
          <h5 style="margin-bottom: 10px;" class="font-weight-bold">Шалгалтын нэр /{{ groupName }}/</h5>
          <div class="card shadow-sm">
            <div class="card-body p-0">
              <table class="table table-bordered table-hover wd-100p mb-0" cellspacing="0">
                  <thead class="bg-light">
                      <tr>
                          <th class="font-weight-bold">Шалгалтын нэр</th>
                          <th class="font-weight-bold">Үр дүн</th>
                          <th class="font-weight-bold">Авсан оноо</th>
                          <th class="font-weight-bold">Шалгалт өгсөн огноо</th>
                          <th class="font-weight-bold">Шалгалтын хүчинтэй хугацаа</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-if="group.length == 0">
                          <td colspan="5" class="text-center bg-gray-50 text-muted">Шалгалт оруулаагүй байна</td>
                      </tr>
                      <tr v-else v-for="(exam, i) in group" :key="i">
                          <td>{{ exam.task }}</td>
                          <td>{{ exam.result_text }}</td>
                          <td>{{ exam.score_display }}</td>
                          <td>{{ exam.dueStartDate | moment("YYYY.MM") }}</td>
                          <td>{{ exam.validity_display }} 
                            <a v-if="exam.courseCertificateView==1" @click="showCert(exam)" 
                            class="btn btn-xs btn-primary">Сертификат татах</a>
                          </td>
                      </tr>
                  </tbody>
              </table>
            </div>
          </div>
      </div>
    </div>

    <file-dialog
      :show="fileDialog.show"
      :id="fileDialog.id"
      @on-hide="fileDialog.show = false"
    />
  </div>
</template>

<script>
//import { getLast3ExamPoint } from "@/api/learn";
import { request } from "@/api/all";
import { getConfigValueByKey } from "@/libs/util";
const moment = require("moment");

var _ = require("lodash");

import AsyncLoading from "@/components/base/asyncLoading";
import AsyncLoadError from "@/components/base/asyncLoadingError";

import html2pdf from 'html2pdf.js';



export default {
  components: {
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
  },
  data() {
    return {
      fileDialog: {
        show: false,
        id: 0
      },
      myResBaseUrl: "https://res.gosmart.mn/",
      lastExams: [],
      passperc: 100,
      before75: "2021-04-01",
      user: {
        lastname: '',
        firstname: '',
        registerno: '',
        createdDate: ''
      },
      examTypes: [],
      onlyPassed: false,
      hideprint: false,
    };
  },
  computed: {
    groupedExams() {
      const groupMapping = this.examTypes.filter(e => e.parentId==0).map(e => e.title);
      // const groupMapping = [
      //   "Сорил шалгалт",
      //   "Эрх олголт",
      //   "Эрх сунгалт"
      // ];
      // Сорил шалгалтын нэрс
      const sorilNames = [
        "Мэдээллийн технологи ур чадвар",
        "Ёс зүй мэргэжлийн үнэ цэнэ",
        "Ёс зүй, мэргэжлийн үнэ цэнэ",
        "Мэргэжлийн англи хэл",
        "Санхүүгийн тайлан гаргах арга зүй"
      ];

      const erhOlgoltNames = [
        "Аудит ба баталгаажуулалт",
        "Хууль, эрх зүй, татварын бүртгэл",
        "Санхүүгийн тайлагнал",
        "Өртөг ба гүйцэтгэлийн удирдлага",
        "Санхүүгийн менежмент"
      ];

      // Эрх сунгалтын нэрс
      const sungaltNames = [
        "Корпорацын тайлагнал",
        "Бизнесийн шинжилгээ ба стратеги",
        "Засаглал, Эрсдэл, Хяналт",
        "Ахисан түвшний санхүүгийн менежмент"
      ];

      const processedExams = this.lastExams.map(exam => {
        let result_text = "Тэнцээгүй";
        let score_display = (exam.b1 === true ? exam.locType1NameNemeltOnoo : exam.perc);
        
        if (exam.b1 === true) {
          result_text = "Дүйцүүлсэн";
        } else if (typeof exam.perc === 'number') {
          if (this.isPassed(exam)) {
            result_text = "Тэнцсэн";
          }
        }
        
        // Mocked validity for now
        let validity_display = "Байнгын";
        // if (exam.task && exam.task.includes("тайлан")) {
        //     validity_display = "2026.06";
        // }
        if(exam.shalgaltHuchinteiDuusah !== null) {
          validity_display = moment(exam.shalgaltHuchinteiDuusah).format("YYYY.MM");
        }

        return {
          ...exam,
          result_text,
          score_display,
          validity_display,
        };
      });

      // Эхлээд groupMapping-д байгаа locTypeId-гаар бүлэглэх
      // const grouped = _.groupBy(processedExams, exam => {

      //   console.log('exam', exam.task, exam, (erhOlgoltNames.includes(exam.task)));

      //   if (groupMapping.includes(exam.parenTaskLocTypeName)) return exam.parenTaskLocTypeName;
      //   // groupMapping-д байхгүй бол task нэрээр нь бүлэглэх
      //   if (sorilNames.some(name => exam.task.includes(name))) return "Сорил шалгалт";
      //   if (erhOlgoltNames.some(name => exam.task.includes(name))) return "Эрх олголт";
      //   if (sungaltNames.some(name => exam.task.includes(name))) return "Эрх сунгалт";
      //   return "-";
      // });
      const grouped= groupMapping;

      // groupMapping дарааллаар, бусад бүлгүүдийг дарааллаар буцаана
      // const order = ["Сорил шалгалт", "Эрх олголт", "Эрх сунгалт"];
      let result = {};
      grouped.forEach(key => {
        // console.log('key', key);
        // if (grouped[key]) {
          // result[key] = _.orderBy(grouped[key], ["dueStartDate", "score_display"], ["asc", "asc"]);
          // result[key] = this.examTypes.filter(e => e.title==key).map(e => {
          //   return {
          //     ...e, task: e.title,
          //   }
          // });
        // }
      });

      // groupMapping-д байхгүй бусад бүлэг байвал нэмэх
      // console.log('grouped', grouped);
      // Object.keys(grouped).forEach(key => {
      //   if (!order.includes(key)) {
      //     result[key] = _.orderBy(grouped[key], "dueStartDate", "asc");
      //   }
      // });
      // console.log('result', result);
      return result;
    }
  },
  created() {
    this.fetchResBase();
  },
  mounted() {
    this.initTypes();
    
    if (this.$store.state.user) {
        this.user = this.$store.state.user.userInfo;
    }
  },
  methods: {
    getValidity(exam){
      let validity_display = "Байнгын";
      if(exam.shalgaltHuchinteiDuusah !== null) {
        validity_display = moment(exam.shalgaltHuchinteiDuusah).format("YYYY.MM");
      }
      return validity_display;
    },
    getScore(exam){
      let score_display = (exam.b1 === true ? exam.locType1NameNemeltOnoo : exam.perc);
      return score_display;
    },
    getResult(exam){
      let result_text = "Тэнцээгүй";
        // let score_display = (exam.b1 === true ? exam.locType1NameNemeltOnoo : exam.perc);
        
        if (exam.b1 === true) {
          result_text = "Дүйцүүлсэн";
        } else if (typeof exam.perc === 'number') {
          if (this.isPassed(exam)) {
            result_text = "Тэнцсэн";
          }
        }
        return result_text;
    },
    turliinShalgaltiigUgsunEseh(typeId){
      let rv= false;
      if(this.lastExams.filter(x=>x.locTypeId==typeId).length>0){
        rv= true;
      }
      // console.log('typeId', typeId, , this.lastExams);
      return rv;
    },
    initTypes(){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "type/getTreeData" },
        params: {
          key: "tmzExamType"
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){
          // console.log('res', res);
          this.examTypes= res.data.types;
          this.init();
        }
      });
      
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    showAttach(id) {
      this.fileDialog.id = id;
      this.fileDialog.show = true;
    },
    showCert(exam){
      console.log('exam', exam);
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "V2/Learn/CreateCertificateFromTemplate" },
        data: {
          id: exam.courseTaskId,
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){
          if (res.data.file.id != 0) {
            this.showAttach(res.data.file.id);
          } else {
            this.$bvToast.toast(
              "Сертификат үүсгэхэд алдаа гарлаа. ахин оролдоно уу",
              {
                title: "Мэдэгдэл",
                autoHideDelay: 500,
                appendToast: true
              }
            );
          }
        }
      });
    },
    printPdf(){
      this.hideprint=true;

      this.$nextTick(() => {

        const element = this.$refs.pdfContent;
        const options = {
          margin:       0.5,
          filename:     'vue2-document.pdf',
          image:        { type: 'jpeg', quality: 0.98 },
          html2canvas:  { scale: 2 },
          jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
        };

        html2pdf().from(element).set(options).save();
        this.hideprint=false;
      });

      
    },
    fetchResBase() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    isPassed(exam) {
       if (this.$store.state.app.activeGroup.id == 6126) {
        if (moment(exam.dueStartDate).isBefore(moment(this.before75))) {
          return exam.perc >= this.passperc;
        } else {
          return exam.perc >= 70;
        }
      } else {
        if(exam.tentsehHuvi>0){
          return exam.perc >= exam.tentsehHuvi;
        }
        return exam.perc >= this.passperc;
      }
    },
    getHighPoint(exam) {
      // console.log('exam', exam);
      if (
        this.lastExams.filter(
          x => x.isJoined == true && 
          x.locTypeId == exam.locTypeId
        ).length > 0
      ) {
        // console.log('this.isJoined', this.lastExams.filter(
        //   x => x.isJoined == true && x.locTypeId == exam.locTypeId
        // ).length);
        let sorted = _.orderBy(
          this.lastExams.filter(
            x => x.isJoined == true && x.locTypeId == exam.locTypeId
          ),
          ["perc", "id"],
          ["desc", "desc"]
        );
        return sorted[0];
      } else {
        return "";
      }
    },
    init() {
      let hdetmp = getConfigValueByKey(
        this.$store.state.app.groupSettings,
        "onlineExamRegistration_passPerc"
      );
      if (hdetmp != undefined) {
        this.passperc = parseInt(hdetmp, 10);
      }

      let self = this;
      request({
        api: { url: "learn/getLast3ExamPoint", method: "get" },
        params: {
          trackUserId: ""
        },
        store: this.$store
      }).then(res => {
        // Get distinct locTypeIds for debugging
        // console.log('Distinct exam types:', [...new Set(res.data.tasks.map(e => e.task))]);
        // console.log('Distinct exam types:', [...new Set(res.data.tasks.map(e => e.locTypeId))]);
        this.lastExams = res.data.tasks.map(e => ({...e})); // Ensure reactivity
        // console.log('lastExams',   this.lastExams);
        
        let uniqueExams = [];
        this.lastExams.forEach(exam => {
          // console.log('exam', exam.locTypeId);
          if (
            uniqueExams.filter(x => x.locTypeId == exam.locTypeId && x.task == exam.task).length == 0
          ) {
            // alert(exam.locTypeId);
            let add = self.getHighPoint(exam);
            if (add != "") {
              uniqueExams.push(add);
              // console.log('add', add);
            }
          }
        });
        this.lastExams = uniqueExams;
        console.log('lastExams', this.lastExams);
        this.$emit('on-last-exams', this.lastExams);
      });
    }
  }
};
</script>
<style>
@media print {
  .no-print {
    display: none !important;
  }
}
</style>
